<!--
 * @Author: Ashley.Liu
 * @Date: 2022-10-31 10:58:35
 * @LastEditTime: 2022-11-07 14:07:19
 * @Description: code editor base on codemirror 5
-->
<template>
  <div
    class="as-code-editor"
    :style="{
      '--height': height,
      '--minHeight': minHeight,
      '--maxHeight': maxHeight,
    }"
  >
    <textarea type="textarea" ref="asCodeEditor"></textarea>
  </div>
</template>

<script>
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/lib/codemirror.js'
import 'codemirror/theme/idea.css'
import 'codemirror/theme/abcdef.css'
import 'codemirror/keymap/sublime'
import jsonConfig from './type/json.config'
import sqlConfig from './type/sql.config'
import deepMerge from 'deepmerge'
require('./js/default')
export default {
  name: 'AsCodeEditor',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    readonly: Boolean,
    mode: {
      type: String,
      default: 'json', // json/sql
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }, // Override default configuration
    },
    enableFold: Boolean,
    height: {
      type: String,
      default: 'auto',
    },
    minHeight: {
      type: String,
      default: '300px',
    },
    maxHeight: {
      type: String,
      default: '1000px',
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        const str = this.getInputStr(val)
        // setValue will causes the cursor to reset to the first,
        // Use with extreme caution.
        if (str !== this.inputStr) {
          this.codeEditor.setValue(str)
          this.inputStr = str
        }
      },
    },
  },
  data() {
    return {
      inputStr: '',
    }
  },
  beforeDestroy() {
    this.codeEditor.off('change')
    this.eventsList.forEach((eventItem) => {
      this.codeEditor.off(eventItem)
    })
  },
  created() {
    this.mergeOptions = {}
    this.handleMode()
    this.handleFold()
    this.eventsList = ['blur', 'focus', 'scroll', 'refresh']
  },
  mounted() {
    const config = this.mode === 'json' ? jsonConfig : sqlConfig
    const options = deepMerge.all([config, this.mergeOptions])

    this.codeEditor = CodeMirror.fromTextArea(this.$refs.asCodeEditor, {
      ...options,
      ...this.options,
    })
    this.inputStr = this.getInputStr(this.value)
    this.codeEditor.setValue(this.inputStr)
    this.codeEditor.on('change', (cm) => {
      this.inputStr = cm.getValue()
      this.$emit('change', this.inputStr)
      // emit input, can use v-model
      try {
        this.$emit(
          'input',
          typeof this.value === 'string'
            ? this.inputStr
            : JSON.parse(this.inputStr)
        )
      } catch (error) {
        console.error('codeEditor input parse error========>>>>>', error)
        // do something
      }
    })
    this.handleOtherEvent()
  },
  methods: {
    getInputStr(value) {
      const str =
        typeof value === 'string' ? value : JSON.stringify(value, null, 2)
      return str
    },
    handleOtherEvent() {
      this.eventsList.forEach((eventItem) => {
        this.codeEditor.on(eventItem, () => {
          this.$emit(eventItem, ...arguments)
        })
      })
    },

    handleMode() {
      if (this.mode === 'json') {
        require('./js/json')
      }
      if (this.mode === 'sql') {
        require('./js/sql')
      }
    },
    handleFold() {
      if (this.enableFold) {
        require('./js/fold')
        this.mergeOptions.foldGutter = {
          rangeFinder: new CodeMirror.fold.combine(
            CodeMirror.fold.indent,
            CodeMirror.fold.comment
          ),
        }
        this.mergeOptions.gutters = ['CodeMirror-foldgutter']
      }
    },
    refresh() {
      this.codeEditor?.refresh()
    },
    setOption(options) {
      this.codeEditor?.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.as-code-editor {
  .CodeMirror,
  .CodeMirror-scroll {
    height: var(--height);
    min-height: var(--minHeight);
    max-height: var(--maxHeight);
  }
}
</style>
